import { DataSource, exampleDataSource } from './DataSource';

export interface BusinessDataSource extends DataSource {
  recommended: boolean;
  lastUsed?: string; // ISO Date
}

export const exampleBusinessDataSource: BusinessDataSource = {
  ...exampleDataSource,
  recommended: true,
  lastUsed: new Date().toISOString(),
};
